export default {
  HOME: {
    name: 'Home',
    routePath: '/',
  },
  SCRAP: {
    name: 'Scrap',
    routePath: '/scrap/product'
  },
  APPLE: {
    name: 'Apple',
    routePath: '/apple',
  },
  VERIFICATION: {
    name: 'Verification',
    routePath: '/verification/token/:token',
  },
  RECOVER_ACCOUNT: {
    name: 'Recover Account',
    routePath: '/recover-account/token/:token',
  },
  ABOUT_US: {
    name: 'About Us',
    routePath: '/about-us',
  },
  QEMPO_TIENDA_MIA: {
    name: 'Qempo Tienda Mia',
    routePath: '/qempo-tiendamia-peru',
  },
  /*QEMPO_AEROPOST: {
    name: 'Qempo Aeropost',
    routePath: '/qempo-aeropost-peru',
  },*/
  QEMPO_ESHOPEX: {
    name: 'Qempo Eshopex',
    routePath: '/qempo-eshopex-peru',
  },
  QEMPO_GRABR: {
    name: 'Qempo Grabr',
    routePath: '/qempo-grabr',
  },
  QEMPO_GUVERY: {
    name: 'Qempo Guvery',
    routePath: '/qempo-guvery-peru',
  },
  QEMPO_SKYBOX: {
    name: 'Qempo SKYBOX',
    routePath: '/qempo-skybox-peru',
  },
  QEMPO_COMPRAENUSA: {
    name: 'Qempo Compraenusa',
    routePath: '/qempo-compraenusa-peru',
  },
  QEMPO_COMPARTOMIMALETA: {
    name: 'Qempo Compartomimaleta',
    routePath: '/qempo-compartomimaleta-peru',
  },
  UNSUBSCRIBE_MAIL_CAMPAIGN: {
    name: 'Unsubscribe Main Campaign',
    routePath: '/unsubscribe/mail-campaign',
  },
  STORES: {
    name: 'Stores',
    routePath: '/stores',
  },
  STORE: {
    name: 'Store',
    routePath: '/store/:name',
  },
  PRODUCTS: {
    name: 'Products',
    routePath: '/products/:name',
  },
  LOGIN: {
    name: 'Login',
    routePath: '/login',
  },
  SIGN_UP: {
    name: 'Sign Up',
    routePath: '/sign-up',
  },

  NEW_FLIGHT: {
    name: 'New Flight',
    routePath: '/new-flight',
  },

  NEW_ORDER: {
    name: 'New Order',
    routePath: '/new-order',
    children: {
      SEARCH: {
        name: 'New Order Search',
        routePath: '/new-order/search',
      },
      PRODUCT: {
        name: 'New Order Product',
        routePath: '/new-order/product',
      },
      QUOTE_OFFLINE_CART: {
        name: 'New Order Quote Virtual Cart',
        routePath: '/new-order/quote/offline-cart',
      },
      QUOTE_CART: {
        name: 'New Order Quote Cart',
        routePath: '/new-order/quote/cart',
      },
      QUOTE_OFFLINE_BAG: {
        name: 'New Order Quote Virtual Bag',
        routePath: '/new-order/quote/offline-bag',
      },
      QUOTE_BAG: {
        name: 'New Order Quote Bag',
        routePath: '/new-order/quote/bag/:id',
      },
      CHECKOUT_ORDER: {
        name: 'New Order Checkout Order',
        routePath: '/new-order/checkout/order/:orderId',
      },
      CHECKOUT_CART: {
        name: 'New Order Checkout',
        routePath: '/new-order/checkout/cart',
      },
      CHECKOUT_BAG: {
        name: 'New Order Checkout',
        routePath: '/new-order/checkout/bag/:bagId',
      },
      CHECKOUT_ITEMS: {
        name: 'New Order Checkout',
        routePath: '/new-order/checkout/items',
      },
      CHECKOUT_ASYNC_ERROR: {
        name: 'New Order Checkout Async Error',
        routePath: '/new-order/checkout-async-error/order/:orderId',
      },
      CHECKOUT_ASYNC_SUCCESS: {
        name: 'New Order Checkout Async Success',
        routePath: '/new-order/checkout-async-success/order/:orderId',
      },
      CHECKOUT_SUCCESS: {
        name: 'New Order Checkout Success',
        routePath: '/new-order/checkout-success/order/:orderId',
      },
    },
  },
  SHOPPING_CART: {
    name: ' Shopping Cart',
    routePath: '/shopping-cart'
  },
  PREFERENCES: {
    name: 'Preferences',
    routePath: '/preferences',
    children: {
      EDIT_PROFILE: {
        name: 'Preferences Edit Profile',
        routePath: '/preferences/edit-profile',
      },
      SECURITY: {
        name: 'Preferences Security',
        routePath: '/preferences/security',
      },
      PASSWORD: {
        name: 'Preferences Password',
        routePath: '/preferences/password',
      },
      SAVED_ADDRESSES: {
        name: 'Preferences Saved Addresses',
        routePath: '/preferences/saved-addresses',
      },
      PAYOUTS: {
        name: 'Preferences Payouts',
        routePath: '/preferences/payouts',
      },
      NOTIFICATIONS: {
        name: 'Preferences Notifications',
        routePath: '/preferences/notifications',
      },
      REFERRAL: {
        name: 'Preferences Referral',
        routePath: '/preferences/referral',
      },
    },
  },

  MY_PAYMENTS: {
    name: 'My Payments',
    routePath: '/my-payments',

    children: {
      MADE: {
        name: 'My Payments Made',
        routePath: '/my-payments/made',
      },
      RECEIVED: {
        name: 'My Payments Received',
        routePath: '/my-payments/received',
      },
    },
  },

  CONTACT: {
    name: 'Contact',
    routePath: '/contact',
  },

  FLIGHTS: {
    name: 'Flights',
    routePath: '/flights',
    children: {
      CURRENT: {
        name: 'Flights Current',
        routePath: '/flights/current',
      },
      PAST: {
        name: 'Flights Past',
        routePath: '/flights/past',
      },
    },
  },

  ORDERS: {
    name: 'Orders',
    routePath: '/orders',
    children: {
      ACTIVE: {
        name: 'Order Active',
        routePath: '/orders/active',
      },
      PAST: {
        name: 'Order Past',
        routePath: '/orders/past',
      },
    },
  },

  PURCHASE: {
    name: 'Purchase',
    routePath: '/purchase/order/:id',
  },
  SALE: {
    name: 'Sale',
    routePath: '/sale/order/:id',
  },

  RESERVE: {
    name: 'Reserve',
    routePath: '/flight/:idFlight/order/:idOrder/reserve',
  },

  FLIGHT: {
    name: 'Flight',
    routePath: '/flight/:id',
    children: {
      REQUESTS: {
        name: 'Flight Requests',
        routePath: '/flight/:id/requests',
      },
      SALES: {
        name: 'Flight Sales',
        routePath: '/flight/:id/sales',
      },
    },
  },
  FLIGHT_LANDING: {
    name: 'Flight Landing',
    routePath: '/public/flight/:id/:user',
  },

  TESTIMONIALS: {
    name: 'Testimonials',
    routePath: '/testimonials',
    children: {
      TRAVELERS: {
        name: 'Testimonials Travelers',
        routePath: '/testimonials/travelers',
      },
    },
  },


  TERMS_OF_SERVICE: {
    name: 'Terms of Service',
    routePath: '/terms-of-service',
  },
  PRIVACY_POLICY: {
    name: 'Privacy Policy',
    routePath: '/privacy-policy',
  },
  HELP_TICKET: {
    name: 'Help Ticket',
    routePath: '/help-ticket',
  },
  BEST_DEALS: {
    name: 'Best Deals',
    routePath: '/best-deals',
  },

  MY_WISH_LISTS: {
    name: 'My Wish Lists',
    routePath: '/my-wish-lists',
  },
  WISH_LIST_USER: {
    name: 'Wish List',
    routePath: '/wish-list/:userId/:nameSlug',
  },
  WISH_LIST_LOCAL: {
    name: 'Wish List',
    routePath: '/wish-list/:nameSlug',
  },
  WISH_LIST_CATALOG: {
    name: 'Wish List Catalog',
    routePath: '/wish-list-catalog',
  },
  FEATURED_PRODUCTS: {
    name: 'Featured Products',
    routePath: '/featured-products',
  },
  POPULAR_PRODUCTS: {
    name: 'Popular Products',
    routePath: '/popular-products',
  },
  CUSTOM_PRODUCT: {
    name: 'Custom Products',
    routePath: '/custom-product',
    children: {
      AIRPODS_WITH_CHARGING_CASE: {
        name: 'AirPods with Charging Case',
        routePath: '/airpods-with-charging-case',
      },
      AIRPODS_WITH_WIRELESS_CHARGING_CASE: {
        name: 'AirPods with Wireless Charging Case',
        routePath: '/airpods-with-wireless-charging-case',
      },
      AIRPODS_PRO: {
        name: 'AirPods Pro',
        routePath: '/airpods-pro',
      },
      AIRPODS_MAX: {
        name: 'AirPods Max',
        routePath: '/airpods-max',
      },
      APPLE_WATCH_6_SPACE_GRAY_ALUMINUM_CASE_SOLO_LOOP: {
        name: 'Apple Watch 6 Space Gray Aluminum Case Solo Loop',
        routePath: '/apple-watch-6-space-gray-aluminum-case',
      },
      APPLE_WATCH_6_SILVER_ALUMINUM_CASE_SOLO_LOOP: {
        name: 'Apple Watch 6 Silver Aluminum Case Solo Loop',
        routePath: '/apple-watch-6-silver-aluminum-case',
      },
      IPHONE_SE_PE: {
        name: 'iPhone SE 2022 Peru',
        routePath: '/iphone-se-2022-peru',
      },
      IPHONE_SE_CO: {
        name: 'iPhone SE 2020 Colombia',
        routePath: '/iphone-se-2022-colombia',
      },
      IPHONE_11_PE: {
        name: 'iPhone 11 Peru',
        routePath: '/iphone-11-peru',
      },
      IPHONE_11_PRO_PE: {
        name: 'iPhone 11 Pro Peru',
        routePath: '/iphone-11-pro-peru',
      },
      IPHONE_11_PRO_MAX_PE: {
        name: 'iPhone 11 Pro Max Peru',
        routePath: '/iphone-11-pro-max-peru',
      },
      IPHONE_11_CO: {
        name: 'iPhone 11 Colombia',
        routePath: '/iphone-11-colombia',
      },
      IPHONE_11_PRO_CO: {
        name: 'iPhone 11 Pro Colombia',
        routePath: '/iphone-11-pro-colombia',
      },
      IPHONE_11_PRO_MAX_CO: {
        name: 'iPhone 11 Pro Max Colombia',
        routePath: '/iphone-11-pro-max-colombia',
      },
      /*IPHONE_12_MINI: {
        name: 'iPhone 12 mini',
        routePath: '/iphone-12-mini',
      },*/
      IPHONE_12: {
        name: 'iPhone 12',
        routePath: '/iphone-12',
      },
      // IPHONE_12_PRO: {
      //   name: 'iPhone 12 Pro',
      //   routePath: '/iphone-12-pro',
      // },
      // IPHONE_12_PRO_MAX: {
      //   name: 'iPhone 12 Pro Max',
      //   routePath: '/iphone-12-pro-max',
      // },
      IPHONE_13_MINI: {
        name: 'iPhone 13 mini',
        routePath: '/iphone-13-mini',
      },
      IPHONE_13: {
        name: 'iPhone 13',
        routePath: '/iphone-13',
      },
      /*IPHONE_13_PRO: {
        name: 'iPhone 13 Pro',
        routePath: '/iphone-13-pro',
      },
      IPHONE_13_PRO_MAX: {
        name: 'iPhone 13 Pro Max',
        routePath: '/iphone-13-pro-max',
      },*/
      IPHONE_14: {
        name: 'iPhone 14',
        routePath: '/iphone-14',
      },
      IPHONE_14_PLUS: {
        name: 'iPhone 14 Plus',
        routePath: '/iphone-14-plus',
      },
      IPHONE_14_PRO: {
        name: 'iPhone 14 Pro',
        routePath: '/iphone-14-pro',
      },
      IPHONE_14_PRO_MAX: {
        name: 'iPhone 14 Pro Max',
        routePath: '/iphone-14-pro-max',
      },
      
      IPHONE_15: {
        name: 'iPhone 15',
        routePath: '/iphone-15',
      },
      IPHONE_15_PLUS: {
        name: 'iPhone 15 Plus',
        routePath: '/iphone-15-plus',
      },
      IPHONE_15_PRO: {
        name: 'iPhone 15 Pro',
        routePath: '/iphone-15-pro',
      },
      IPHONE_15_PRO_MAX: {
        name: 'iPhone 15 Pro Max',
        routePath: '/iphone-15-pro-max',
      },
      
      IPHONE_16: {
        name: 'iPhone 16',
        routePath: '/iphone-16',
      },
      IPHONE_16_PLUS: {
        name: 'iPhone 16 Plus',
        routePath: '/iphone-16-plus',
      },
      IPHONE_16_PRO: {
        name: 'iPhone 16 Pro',
        routePath: '/iphone-16-pro',
      },
      IPHONE_16_PRO_MAX: {
        name: 'iPhone 16 Pro Max',
        routePath: '/iphone-16-pro-max',
      },
      
      IPAD_PRO_11_INCH_WIFI: {
        name: 'Ipad Prod',
        routePath: '/ipad-pro-11-inch-wifi'
      },
      IPAD_PRO_12_9_INCH_WIFI: {
        name: 'Ipad Prod',
        routePath: '/ipad-pro-12.9-inch-wifi'
      },
      IPAD_PRO_11_INCH_WIFI_CELL: {
        name: 'Ipad Prod',
        routePath: '/ipad-pro-11-inch-wifi-cell'
      },
      IPAD_PRO_12_9_INCH_WIFI_CELL: {
        name: 'Ipad Prod',
        routePath: '/ipad-pro-12.9-inch-wifi-cell'
      },

      IPAD_AIR_10_9_INCH_WIFI: {
        name: 'Ipad Air',
        routePath: '/ipad-air-10.9-inch-wifi'
      },
      IPAD_AIR_10_9_INCH_WIFI_CELL: {
        name: 'Ipad Air',
        routePath: '/ipad-air-10.9-inch-wifi-cell'
      },
      
      SAMSUNG_GALAXY_S20_PE: {
        name: 'Samsung Galaxy S20 Peru',
        routePath: '/samsung-galaxy-s20-peru',
      },
      SAMSUNG_GALAXY_S20_PLUS_PE: {
        name: 'Samsung Galaxy S20+ Peru',
        routePath: '/samsung-galaxy-s20+-peru',
      },
      SAMSUNG_GALAXY_S20_ULTRA_PE: {
        name: 'Samsung Galaxy S20 Ultra Peru',
        routePath: '/samsung-galaxy-s20-ultra-peru',
      },
      SAMSUNG_GALAXY_S20_CO: {
        name: 'Samsung Galaxy S20 Colombia',
        routePath: '/samsung-galaxy-s20-colombia',
      },
      SAMSUNG_GALAXY_S20_PLUS_CO: {
        name: 'Samsung Galaxy S20+ Colombia',
        routePath: '/samsung-galaxy-s20+-colombia',
      },
      SAMSUNG_GALAXY_S20_ULTRA_CO: {
        name: 'Samsung Galaxy S20 Ultra Colombia',
        routePath: '/samsung-galaxy-s20-ultra-colombia',
      },
      PLAYSTATION_5: {
        name: 'PlayStation 5',
        routePath: '/ps5',
      },
      PLAYSTATION_5_DIGITAL_EDITION: {
        name: 'PlayStation 5 Digital Edition',
        routePath: '/ps5-digital-edition',
      },
    },
  },

  CARGO: {
    name: 'Cargo',
    routePath: '/cargo',
  },
  COURIER: {
    name: 'Courier',
    routePath: '/courier',
    children: {
      RECEPTION: {
        name: 'Reception',
        routePath: '/courier/reception',
      },
    },
  },
  TIENDAS: {
    name: 'Tiendas',
    routePath: '/tiendas',
  },
  NOT_FOUND: {
    name: 'Not Found',
  },
};



// WEBPACK FOOTER //
// ./src/routes.js